<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-tabs>
          <v-tab>
            Telefonbuch
          </v-tab>
          <v-tab-item>
            <pb-manage></pb-manage>
          </v-tab-item>
          <v-tab-item>
            <pb-datamaintenance></pb-datamaintenance>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PbManage from "../components/phonebook/pb-manage";
export default {
  name: "PhonebookView",
  components: { PbManage },
  data: () => ({

  }),
  mounted() {
    this.$store.dispatch("update", { "context": "/phonebook" })
  }

};
</script>

<style scoped>

</style>
